/* eslint-disable @typescript-eslint/no-unused-vars */ import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Logo = function(_param) {
    var isDark = _param.isDark, props = _object_without_properties(_param, [
        "isDark"
    ]);
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 190 40"
    }, props), {
        children: isDark ? /*#__PURE__*/ _jsx("image", {
            width: 160,
            href: "/images/logoWithText-dark.png"
        }) : /*#__PURE__*/ _jsx("image", {
            width: 160,
            href: "/images/logoWithText.png"
        })
    }));
};
export default /*#__PURE__*/ React.memo(Logo, function(prev, next) {
    return prev.isDark === next.isDark;
});
